export default __webpack_public_path__ + "static/media/AI_news.4173f656.png";